import Vue from 'vue'
import money from './money-function.js';

Vue.directive('money', {
  twoWay: true,
  bind(el, binding, vnode) {
    if (vnode.data.model) {
      const formated = money(vnode.data.model.value, binding.value);
      vnode.componentInstance.$emit('input', formated);

      el.addEventListener('input', event => {
        const formated = money(event.target.value || 0, binding.value); //binding.value = v-money="{}" params
        event.target.value = formated;
        vnode.componentInstance.$emit('input', formated);
      });
    }

    // start setup on value
    //const formated = money(vnode.data.model.value, binding.value);
    //vnode.componentInstance.$emit('input', formated);
  },
  //inserted(el, binding, vnode) {},
  update(el, binding, vnode) {
    if (vnode.data.model) {
      const formated = money(vnode.data.model.value, binding.value);
      vnode.componentInstance.$emit('input', formated);
    }
  },
  //componentUpdated(el, binding, vnode, oldVnode) {}
});
